export default "__VITE_ASSET__CQSyMlEP__"